module.exports = __webpack_public_path__ + "static/media/partnerAdvantage2.adbe8892.svg";